module.exports = __webpack_public_path__ + "img/info.d5d98d3c.jpg";